import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { hasPermission } from "../../utils/permissionUtils";
import {
  Dashboard,
  DesktopWindows,
  RingVolume,
  Timeline,
  Code,
  Settings,
  ContactSupport,
} from "@mui/icons-material";

const useWidgetItems = () => {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    if (!isInitialized) return;

    if (!isAuthenticated) {
      setNavItems([]);
      return;
    }

    // Always show widget-specific navigation regardless of user type
    setNavItems([
      {
        title: "Widget",
        pages: [
          hasPermission("VIEW_WIDGET_DASHBOARD") && {
            href: "/widget/dashboard",
            icon: Dashboard,
            title: "Dashboard",
          },
          hasPermission("VIEW_VISITOR_ANALYTICS") && {
            href: "/widget/visitors",
            icon: DesktopWindows,
            title: "Visitors",
          },
          hasPermission("VIEW_INCOMING_REQUESTS") && {
            href: "/widget/incoming-requests",
            icon: RingVolume,
            title: "Incoming Requests",
          },
          hasPermission("VIEW_VISITOR_ANALYTICS") && {
            href: "/widget/lead-overview",
            icon: Timeline,
            title: "Lead Overview",
          },
          hasPermission("VIEW_CHANNEL_CONNECT") && {
            href: "/widget/channel-connect",
            icon: Code,
            title: "Channel Connect",
          },
          hasPermission("VIEW_SUPPORT_TICKETS") && {
            href: "/widget/support-tickets",
            icon: ContactSupport,
            title: "Support Tickets",
          },
          hasPermission("UPDATE_WIDGET_SETTINGS") && {
            href: "/widget/settings",
            icon: Settings,
            title: "Settings",
          },
        ].filter(Boolean),
      },
    ]);
  }, [isInitialized, isAuthenticated, user]); // Dependencies are now stable

  return navItems;
};

export default useWidgetItems;
